import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=bf4cb054&"
import script from "./PivotTable.vue?vue&type=script&lang=js&"
export * from "./PivotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports